import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "modules/auth/LoginPage";
import SignUpPage from "modules/auth/SignUpPage";
import { useAuth,  } from "providers/AuthProvider";
import { registerWebNotification  } from "api/auth";
import CompleteSignUp from "modules/auth/CompleteSignUp";
import MainLayout from "layouts/MainLayout";
import Tests from "modules/tests/Tests";
import GlobalLoadingIndicator from "generics/GlobalLoadingIndicator";
import AppointmentsPage from "modules/appointments/AppointmentsPage";
import AppointmentDetailPage from "modules/appointments/AppointmentDetailPage";
import ProfilePage from "modules/profile/ProfilePage";
import AllAppointmentsPage from "modules/appointments/AllAppointmentsPage";
import TransactionsPage from "modules/transactions/TransactionsPage";
import Services from "modules/services/Services";
import ActivePatientsPage from "modules/appointments/ActivePatientsPage";
import CategoriesPage from "modules/categories/CategoriesPage";
import FamilyCardPage from "modules/familyCards/FamilyCards";
import FamilyCardDetail from "modules/familyCards/FamilyCardDetail";
import Reviews from "modules/reviews/Reviews";
import AddTest from "modules/tests/AddTest";
import AddService from "modules/services/AddService";
import PatientDetailsPage from "modules/appointments/PatientDetailsPage";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

export function App() {
  const { auth: isLoggedIn, lab } = useAuth();

  if (!isLoggedIn)
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );

  if (!lab?.complete)
    return (
      <Routes>
        <Route path="/complete" element={<CompleteSignUp />} />
        <Route path="*" element={<Navigate to="/complete" />} />
      </Routes>
    );

  return (
    <MainLayout>
      <GlobalLoadingIndicator />
      <Routes>
        <Route path="/tests" element={<Tests />} />
        <Route path="/tests/add" element={<AddTest />} />
        <Route path="/tests/:testId" element={<AddTest edit />} />
        <Route path="/patients" element={<ActivePatientsPage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/appointments/all" element={<AllAppointmentsPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/discountcards" element={<FamilyCardPage />} />
        <Route path="/discountcards/:id" element={<FamilyCardDetail />} />
        <Route path="/appointments/:id" element={<AppointmentDetailPage />} />
        <Route
          path="/appointments/:id/:patientId"
          element={<PatientDetailsPage />}
        />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/add" element={<AddService />} />
        <Route path="/services/:serviceId" element={<AddService edit />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="*" element={<Navigate to="/patients" />} />
      </Routes>
    </MainLayout>
  );
}
